document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth > 768) return;

  document.querySelectorAll('rte-formatter table').forEach(function (table) {

    if (table.closest('.auto-mobile-table-scroll')) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'auto-mobile-table-scroll';

    const inner = document.createElement('div');
    inner.className = 'auto-mobile-table-scroll-inner';

    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(inner);
    inner.appendChild(table);
  });
});
